import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
//import { Select } from 'semantic-ui-react';
import { Icon, Input, Button, Dropdown, Grid, Card, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react';
import { getkpidata, getkpidata1, getAgingDashboard,Fetchexecutequery,Fetchexecutequery1, getkpidata3, getexceptiondata, getkpidata4, getexceptiondata1, getProcessingLayerListFromServer, getdashboard1sidement } from '../../../services/process/BRS1/brsService1';
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'semantic-ui-css/semantic.min.css';
import Modal from 'react-bootstrap/Modal';
import * as XLSX from 'xlsx';


import './dashboard_new.css';

import Accordion from 'react-bootstrap/Accordion';

import DualBarGraph from './dual_bar_graph';

// import icici from '../../../assets/images/icici.png';
import SearchInput from './search_input';
// import Select from "react-select";

// import { faAlignCenter } from '@fortawesome/free-solid-svg-icons';


const DashboardComponent = () => {
  const [input1, setInput1] = useState('');
  const [inputMonth, setInputMonth] = useState('');
  const [selectedmonth, setSelectedmonth] = useState('');
  const [selectedyear, setSelectedyear] = useState('');
  const [selectedLabel, setSelectedLabel] = useState('');
  const [input2, setInput2] = useState('');
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [seriesdonut, setseriesdonut] = useState();
  const [serieslabels, setserieslabels] = useState([]);
  const [seriesdata, setseriesdata] = useState([]);
  const [extGridData, setExtGridData] = useState([]);
  const [modelcolumnnames, setmodelcolumnnames] = useState([]);
  const [selectedValues, setSelectedValues] = useState();

  const [serieslabels1, setserieslabels1] = useState([]);
  const [seriesdata1, setseriesdata1] = useState([]);
  const [serieslabels2, setserieslabels2] = useState([]);
  const [seriesdata2, setseriesdata2] = useState([]);

  const [kpidata2, setkpidata2] = useState([]);

  const [show, setShow] = useState(false);

  const [options, setOptions] = useState([]);
  const [options1, setOptions1] = useState([]);
  const [filterText, setFilterText] = useState('');

  const [clientids, setclientids] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState('');
  const [selectedcustomer, setselectedcustomer] = useState('');


  const [userid, setuserid] = useState(userCredentials["user_id"]);

  const [doughnutLabel, setDoughnutLabel] = useState([]);
  const [doughnutdata, setDoughnutData] = useState([]);
  const [doughnutLabel1, setDoughnutLabel1] = useState([]);
  const [doughnutdata1, setDoughnutData1] = useState([]);
  const [doughnutLabel123, setDoughnutLabel123] = useState([]);
  const [doughnutdata123, setDoughnutData123] = useState([]);
  const [barwidth, setbarwidth] = useState('40%');
  const [radialseries, setradialseries] = useState([89.52]);
  const [options123, setoptions123] = useState(['']);
  const [selectedOptions123, setselectedOptions123] = useState('CORPORATE');

  let sideinfo_list = [];

  const handleDataPointSelection = (event, chartContext, config) => {
    setSelectedLabel(config.dataPointIndex);
    // Here you can send the selected label wherever you need
  };
const Option123 = [
    { key: 'UTR Mailer', text: 'UTR Mailer', value: 'UTR Mailer' },
    { key: 'Payments', text: 'Payments', value: 'Payments' },
    { key: 'Consolidation', text: 'Consolidation', value: 'Consolidation' },
    { key: 'BRS', text: 'BRS', value: 'BRS' },
    { key: 'Insurance', text: 'Insurance', value: 'Insurance' },
    // Add more options as needed
  ];
  const chartDatanew = {
    series: doughnutdata,
    options: {
      labels: doughnutLabel,
      colors: ['#264be0', '#5a63c4', '#0A2352', '#b84dff', '#ff944d', '#00cccc', '#3E4C5E', '#4381C1', '#80A1C1', '#C7D3DD'],
      legend: {
        onItemClick: {
          toggleDataSeries: false,
        },

      },
      chart: {
        width: 280,
        height: 370,
        type: 'donut',
        events: {
          dataPointSelection: function(event, chartContext, config) {
            try {
             const selectedLabel1 = config.w.config.labels[config.dataPointIndex];
             console.log("Selected Label Retrieved:", selectedLabel1);
             getFirstcarddata6(selectedLabel1);
           } catch (error) {
             console.error("Error handling data point selection:", error);
           }
         },
       },
      },
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 270
        },
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        type: 'gradient',
      },
      // legend: doughnutLabel,
      title: {
        text: ''
      },

      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
            height: 250,
          },
          legend: {
            position: 'bottom'
          }
        }
      }],
    },
  };

    const handleChange1 = (event) => {
        const newValue = event.target.value;
        console.log('selected val,' + newValue,inputMonth);
        setSelectedValues(newValue);
    }

    const handleChange3 = (event) => {
        const newValue12 = event;
        console.log('selected month:' + newValue12);
        setInputMonth(newValue12);
        const [year, month] = newValue12.split('-');
        console.log('Year:', year);   // Output: Year: 2024
        console.log('Month:', month); // Output: Month: 06
        setSelectedmonth(month);
        setSelectedyear(year);
        
    }


    const handleChange2 = () => {
	if (selectedValues === 'UTR Mailer') {
   	     const email = 'rajeev.bharadwaj@teamlease.com';
    	     const password = 'rajeev@1234$';
    	     const loginUrl = `http://172.16.40.14:3000/1/`;
    	    // Open the login page with query parameters in a new tab
   	    window.open(loginUrl, '_blank');

  	} else if (selectedValues === 'Payments') { // Use the correct value here
  	  window.open('http://172.16.40.13/payments/approver_home/vikram@teamlease.com/new_invoices_approver/', '_blank');
 	} else if (selectedValues === 'Consolidation') { // Use the correct value here
  	  const loginUrl = `http://172.16.40.14:3301/1/`;

   	  // Open the login page with query parameters in a new tab
  	  window.open(loginUrl, '_blank');

 	} else if (selectedValues === 'BRS') { // Use the correct value here
  	  const email = 'balakrishna.m@teamlease.com';
   	  const password = 'bala@1234';

   	  const loginUrl = `http://172.16.40.14:3250/1/`;

   	  // Open the login page with query parameters in a new tab
  	  window.open(loginUrl, '_blank');

 	} else if (selectedValues === 'Insurance') { // Use the correct value here
  	  console.log('Insurance');
 	}
    }



  const chartDatanew1 = {
    series: doughnutdata1,
    options: {
      labels: doughnutLabel1,
      colors: ['#264be0', '#5a63c4', '#0A2352', '#b84dff', '#ff944d', '#00cccc', '#3E4C5E', '#4381C1', '#80A1C1', '#C7D3DD'],
      legend: {
        onItemClick: {
          toggleDataSeries: false,
        },

      },
      chart: {
        width: 280,
        height: 370,
        type: 'donut',
        events: {
           dataPointSelection: function(event, chartContext, config) {
             try {
              const selectedLabel = config.w.config.labels[config.dataPointIndex];
              console.log("Selected Label Retrieved:", selectedLabel);
              getFirstcarddata4(selectedLabel);
            } catch (error) {
              console.error("Error handling data point selection:", error);
            }
          },
        },
      },
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 270
        },
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        type: 'gradient',
      },
      // legend: doughnutLabel,
      title: {
        text: ''
      },

      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
            height: 250,
          },
          legend: {
            position: 'bottom'
          }
        }
      }],

    },
  };

  const intColumnDefs3 = React.useMemo(() => {
    if (extGridData && extGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(extGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs = [

        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true
        })),
      ];
      setmodelcolumnnames(intColumnDefs);
      // console.log('intColumnDefs', intColumnDefs);
      return intColumnDefs;
    }
    return [];
  }, [extGridData]);

  function utrinfo3() {
    let payload = {
      query : `SELECT DATE(last_send_on) AS 'date',COUNT(client_id) AS 'count'  FROM alcs.alcs_mail_logs WHERE MONTH(last_send_on) = '05' GROUP BY DATE(last_send_on);`
    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          // let data1 = data['outstanding_value'];
          setExtGridData(data);
          setShow(true);
          
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  function ageinginfo11() {
    let payload = {
      query : `select * from Vendor_Reconcilation_System.vendor_statement where status = 'Unmatched';`
    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          // let data1 = data['outstanding_value'];
          setExtGridData(data);
          setShow(true);
          
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }
  function getKpiinfo3() {
  
          setShow(true);
        }

  function getKpiinfo4() {
    
          setShow(true);
       
  }

  const handleBarClick1 = (event, chartContext, config) => {
    console.log('clicked');
    ageinginfo11();
  };

  const changedropdown1 = (event, { value }) => {
    console.log("event",value)
    setselectedOptions123(value)
    getinvoicedetailsdashboard(value)
  }


  const handleBarClick = (event, chartContext, config) => {
    console.log('clicked');
    // getKpiinfo4();
    utrinfo3()
  };

  const chartData1 = {
    series: [
      {
        name: 'Series 1',
        data: seriesdata,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 450,
        toolbar: {
          show: false // Hide the toolbar
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: '30%'
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: serieslabels,
      },
      
      fill: {
        colors: ['#0a2352'],
      },
    },
  };

    const chartData2 = {
    series: [
      {
        name: 'Series 1',
        data: seriesdata1,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 250,
        toolbar: {
          show: false // Hide the toolbar
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: barwidth
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: serieslabels1,
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            // Format the y-axis labels as lakhs
            return (value / 1);
          },
        },
      },
      fill: {
        colors: ['#0a2352'],
      },
    },
  };

  const chartData3 = {
    series: [
      {
        name: 'Series 1',
        data: seriesdata2,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 200,
        toolbar: {
          show: false // Hide the toolbar
        },
        events: {
          click: function(event, chartContext, config) {
            // Check if the click occurred on a data point
          if (config && config.dataPointIndex !== undefined && config.dataPointIndex !== -1) {
            const clickedLabel = serieslabels2[config.dataPointIndex];
            console.log("Clicked data point label:", clickedLabel);
            getExceptiontypedata45(clickedLabel);
            // Perform actions specific to data point clicks
          } else {
            // Check if the click occurred on an x-axis label
            const xaxisLabels = document.querySelectorAll('.apexcharts-xaxis-label');
            xaxisLabels.forEach((label, index) => {
              label.addEventListener('click', function() {
                const clickedLabel = serieslabels2[index];
                console.log("Clicked x-axis label:", serieslabels2.length,index,serieslabels2[index - (serieslabels2.length+1)]);
                getExceptiontypedata45(clickedLabel);
                // Perform actions specific to x-axis label clicks
              });
            });
          }
        }
      }  
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: barwidth
        },
      },
      dataLabels: {
        enabled: false,
        wrap: true
      },
      xaxis: {
        categories: serieslabels2,

        labels: {
          show: true,
          rotate: 0, // Rotate labels if necessary to fit more characters
          minHeight: 30, // Set minimum height for labels to accommodate longer names
          style: {
            fontSize: '8px', // Adjust font size if needed 
          },
          onClick:{handleBarClick}
         },
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            // Format the y-axis labels as lakhs
            return (value / 1);
          },
        },
      },
      fill: {
        colors: ['#0a2352'],
      },
    },
  };

  const [totalsales, settotalsales] = useState('')
  const [overdueamount, setoverdueamount] = useState('')

  function getKpiinfo() {
    let payload = {
      query : `
      SELECT
    age_bucket,
    COUNT(*) AS count_in_bucket
FROM
    (
        SELECT
            primary_id,
            date,
            status,
            CASE
                WHEN DATEDIFF('2023-05-20', STR_TO_DATE(date, '%d-%m-%Y')) <= 30 THEN '0-1'
                WHEN DATEDIFF('2023-05-20', STR_TO_DATE(date, '%d-%m-%Y')) <= 90 THEN '1-3 '
                WHEN DATEDIFF('2023-05-20', STR_TO_DATE(date, '%d-%m-%Y')) <= 180 THEN '3-6'
                WHEN DATEDIFF('2023-05-20', STR_TO_DATE(date, '%d-%m-%Y')) <= 365 THEN '6-12'
                ELSE '>12'
            END AS age_bucket
        FROM
            Vendor_Reconcilation_System.vendor_statement
    ) AS age_grouped
WHERE
    status = 'Unmatched'
GROUP BY
    age_bucket
ORDER BY
    CASE
        WHEN age_bucket = '0-1' THEN 1
        WHEN age_bucket = '1-3 ' THEN 2
        WHEN age_bucket = '3-6' THEN 3
        WHEN age_bucket = '6-12' THEN 4
        ELSE 5
    END;

  `

    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("aging dashboard data!!!", response)
          let data = response["data"];
          let filteredData = data;
          const labels = filteredData.map(item => item.age_bucket);
          const series = filteredData.map(item => item.count_in_bucket);
 
          // settotalsales(labels);
          // setoverdueamount(series);
                  
          setserieslabels(labels);
          setseriesdata(series);

          // let table_data = data["data1"];
          // setExtGridData(table_data);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  function getagingdashboard() {
    let payload = {
      query: `SELECT 
    count(client_id) AS 'count', 
    day(last_send_on) AS 'date' 
FROM 
    alcs.alcs_mail_logs 
WHERE 
    last_send_on >= DATE_SUB(CURDATE(), INTERVAL 7 DAY) 
GROUP BY 
    day(last_send_on) 
ORDER BY 
    day(last_send_on) ASC;
`

    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("aging dashboard data!!!", response)
          let data = response["data"];
          let filteredData = data;
          const labels = filteredData.map(item => item.date);
          const series = filteredData.map(item => item.count);
          setserieslabels1(labels);
          setseriesdata1(series);

          let arrayLength = [];
          let datesArray = labels;
          arrayLength = datesArray && datesArray?.length;

          if (arrayLength == 3) {
            setbarwidth('40%')
          } else if (arrayLength == 2) {
            setbarwidth('30%')
          } else if (arrayLength == 1) {
            setbarwidth('10%')
          }
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data of UTR!!!", error);
        }
      );
  }

  
  function getinvoicedetailsdashboard(department) {
    let payload = {
      query: `SELECT ifnull(invoice_status, 'none') as 'status', count(*) as count FROM payments.approved_invoices where month(invoice_date)='${selectedmonth}' and year(invoice_date)=${selectedyear} and entity_id != 2 and invoice_type = '${department}' and is_active=1 group by invoice_status
              union all
              select 'all' as 'status',count(*) FROM payments.approved_invoices where month(invoice_date)='${selectedmonth}' and year(invoice_date)='${selectedyear}' and entity_id != 2 and invoice_type = '${department}' and is_active=1;`
              }

    var getProcessingLayerDataWithStatus = Fetchexecutequery1();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          let data = response["data"];
          let filteredData = data;
          const labels = filteredData.map(item => item.status);
          const series = filteredData.map(item => item.count);
          console.log("aging dashboard data!!!", labels,series)

          setDoughnutLabel123(labels);
          setDoughnutData123(series);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data of UTR!!!", error);
        }
      );
  }

  const chartData123 = {
    labels: doughnutLabel123,
    series: doughnutdata123,
  };


  const DynamicDonutChart = ({ options, series, onClick }) => {
    const handleDataPointSelection = (event, chartContext, config) => {
      console.log('Data:', chartData.series, chartData.options.labels);
      console.log('Event:', event);
      if (config && config.w && config.w.config && config.w.config.labels && config.dataPointIndex !== undefined) {
        const selectedLabel = config.w.config.labels[config.dataPointIndex];
        if (selectedLabel) {
          console.log('selectedLabel', selectedLabel);
          onClick(selectedLabel);
        }
      }
    };

    const chartData = {
      series: series,
      options: {
        labels: options,
        colors: ['#264be0', '#5a63c4', '#0A2352', '#b84dff', '#ff944d', '#00cccc'],
        legend: {
          onItemClick: {
            toggleDataSeries:function(seriesIndex) {
          // Access the chart instance
          const chart = this.chart;

          // Check if the data series is visible
          if (chart.series[seriesIndex].visible) {
            // Hide the data series
            chart.hideSeries(seriesIndex);
          } else {
            // Show the data series
            chart.showSeries(seriesIndex);
          }
        }
          },

        },
        chart: {
          width: 180,
          height: 270,
          type: 'donut'
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270
          },
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          type: 'gradient',
        },
        
        title: {
          text: ''
        },

        responsive: [{
          breakpoint: 280,
          options: {
            chart: {
              width: 100,
              height: 150,
            },
            legend: {
              position: 'bottom'
            }
          }
        }],
        chart: {
          events: {
            dataPointSelection: handleDataPointSelection
          }
        }
      },
    };

    useEffect(() => {
      if (chartData.series.length > 0) {
        // Reinitialize the chart when data is available
        chartData.options.chart.events = {
          dataPointSelection: handleDataPointSelection
        };
      }
    }, [chartData.series]);  

    return (
      <div id="chart-container">
        <ReactApexChart options={chartData.options} series={chartData.series} type="donut" />
      </div>
    );
  };

  function getinvoiceoptionsdashboard() {
    let payload = {
      query: `SELECT distinct invoice_type FROM payments.approved_invoices where entity_id in (1,3,4);`
    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery1();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          let data = response["data"];
          console.log('data of p2p',data)
          let options13 = data.map((item, index) => ({
            key: index, // unique key for each item
            value: item.invoice_type,
            text: item.invoice_type
          }));
  ;
          setoptions123(options13)
        }
      ).catch(
        error => {
          console.log("Error in getting options for p2p dropdown!!!", error);
        }
      );
  }
  const [item, setitem] = useState({});
  const [item1, setitem1] = useState({});
  const [item2, setitem2] = useState({});
  const [item3, setitem3] = useState({});
  const [item4, setitem4] = useState('');
  const [item5, setitem5] = useState('');
  const [item6, setitem6] = useState('');
  const [item7, setitem7] = useState('');
  const [urls, seturls] = useState([]);

  const [show19, setshow19] = useState(true);

  const [secoundlabel, setsecoundlabel] = useState(['dispute', 'Funding']);
  const [secounddata, setsecounddata] = useState([104356, 678654]);
  const [secoundlabel1, setsecoundlabel1] = useState([]);
  const [secounddata1, setsecounddata1] = useState([]);
  const [outstandval, setoutstandval] = useState([]);
  const [overdueval1, setoverdueval1] = useState([]);
  const [totalval, settotalval] = useState([]);
  const [exceptionval, setexceptionval] = useState([]);
  const [disputeval, setdisputeval] = useState([]);


  function getKpiinfo1() {
    let payload = {
      query : `SELECT count(*) as count,'Open' AS result_type FROM BRS.month_end_closing_balance WHERE month = '11-2023' and lock_status=0
      UNION ALL
      SELECT count(*) as count,'Closed' AS result_type FROM BRS.month_end_closing_balance WHERE month = '11-2023' and lock_status=1;`
    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status !!!", response)
          let data = response["data"];
          const division = data.map(item => item.result_type);
          const divisionCount = data.map(item => item.count);


         
          setsecoundlabel(division);
          setsecounddata(divisionCount);
          setDoughnutLabel(division);
          setDoughnutData(divisionCount)

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data for BRS data!!!", error);
        }
      );
  }


  function getKpiinfo12() {
    let payload = {
      query: `
        SELECT count(*) AS result_count, 'Processed Files' AS result_type FROM 
            consolidation.file_uploads 
        WHERE 
            SUBSTRING(month, 1, 4) = '${selectedyear}' 
            AND SUBSTRING(month, 6, 2) = '${selectedmonth}' 
            AND status = 'BATCH'
        
        UNION ALL
        
        SELECT count(*) AS result_count, 'Not Processed Files' AS result_type
        FROM 
            consolidation.source_master 
        WHERE 
            consolidation.source_master.source_identifier NOT IN (
                SELECT 
                    file_type 
                FROM 
                    consolidation.file_uploads  
                WHERE 
                    SUBSTRING(month, 1, 4) = '${selectedyear}' 
                    AND SUBSTRING(month, 6, 2) = '${selectedmonth}' 
                    AND status = 'BATCH' 
                GROUP BY 
                    file_type
            );`     
    }

    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          const division = data.map(item => item.result_type);
          //const division = ['Processed'];
          const divisionCount = data.map(item => item.result_count);


         
          setsecoundlabel1(division);
          setsecounddata1(divisionCount);
          setDoughnutLabel1(division);
          setDoughnutData1(divisionCount)

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  useEffect(() => {
    const currentDate = new Date();
    // Get current year and month
    const currentYear = currentDate.getFullYear();
    const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Pad month with leading zero
    // Format as YYYY-MM
    const formattedDate = `${currentYear}-${currentMonth}`;
    // Call handleChange3 with the current month
    handleChange3(formattedDate);
  }, []
  );

useEffect(() => {
    if (selectedmonth && selectedyear) {
      getagingdashboard();
      getKpiinfo1();
      getinvoicedetailsdashboard('CORPORATE');
      getinvoiceoptionsdashboard();
      getKpiinfo12();
    }
  }, [selectedmonth, selectedyear]);

  const handleIconClick5 = () => {
    // Redirect to the desired URL
    window.location.href = '/reconsummaryvrs2'; // Replace with your URL
  };

  const handleClose = () => {

    setShow(false);
  }



  function getExceptiontypedata(exception) {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["entities_id"],
      'user_id': userCredentials["user_id"],
      'exception': exception,

    }

    var getProcessingLayerDataWithStatus = getexceptiondata();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setExtGridData(data1);
          setShow(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  function getExceptiontypedata1(exception) {
    console.log("exception",exception)
    let payload;
    if (exception === "Processed Files") {
    payload = { query : `SELECT fu.file_type,sm.source_description FROM consolidation.file_uploads fu
          INNER JOIN 
              consolidation.source_master sm 
          ON 
              fu.file_type = sm.source_identifier 
          WHERE 
              SUBSTRING(fu.month, 1, 4) = '2024' AND SUBSTRING(fu.month, 6, 2) = '05' AND fu.status = 'BATCH';`};
    } else if (exception === "Not Processed Files") {
    payload = { query: `SELECT sm.source_identifier, sm.source_description FROM consolidation.source_master sm WHERE sm.source_identifier 
		NOT IN ( SELECT fu.file_type FROM consolidation.file_uploads fu 
		WHERE  SUBSTRING(fu.month, 1, 4) = '2024' AND SUBSTRING(fu.month, 6, 2) = '05' AND fu.status = 'BATCH' GROUP BY fu.file_type);` };
 	       }

    console.log("payload", payload);
    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setExtGridData(data);
          setShow(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  const handleChartClick = (label) => {
    if(label == 'All'){
      getExceptiontypedata46()
    }else{
      getExceptiontypedata45(label)
    }
  };

  function getExceptiontypedata45(exception) {
    console.log("exception",exception)
    let payload;
   
    payload = { query : `SELECT IFNULL(TRIM(vendor_name), '') AS 'Vendor Name', IFNULL(TRIM(vendor_address), '') AS 'Vendor Address', IFNULL(TRIM(place_of_supply), '') AS 'Place Of Supply', IFNULL(TRIM(invoice_number), '') AS 'Invoice Number', IFNULL(DATE_FORMAT(invoice_date, '%d-%m-%Y'), '') AS 'Invoice Date', IFNULL(CONVERT(cgst_percent, CHAR), '0.00') AS 'Cgst Percent', IFNULL(CONVERT(cgst_amount, CHAR), '0.00') AS 'Cgst Amount', IFNULL(CONVERT(sgst_percent, CHAR), '0.00') AS 'Sgst Percent', IFNULL(CONVERT(sgst_amount, CHAR), '0.00') AS 'Sgst Amount', IFNULL(CONVERT(igst_percent, CHAR), '0.00') AS 'Igst Percent', IFNULL(CONVERT(igst_amount, CHAR), '0.00') AS 'Igst Amount', IFNULL(CONVERT(total_invoice_amount, CHAR), '0.00') AS 'Invoice Amount', IFNULL(TRIM(purchase_order_number), '') AS 'PO Number', IFNULL(DATE_FORMAT(purchase_order_date, '%d-%m-%Y'), '') AS 'PO Date', IFNULL(TRIM(cost_center_code), '') AS 'Cost Centre Code', IFNULL(TRIM(approver_mail_id), '') AS 'Approver', IFNULL(TRIM(expense_code), '') AS 'Expense Code', IFNULL(TRIM(expense_category), '') AS 'Expense Category', IFNULL(TRIM(invoice_type), '') AS 'Invoice Type', IFNULL(TRIM(invoice_user_mail_id), '') AS 'Sent By', IFNULL(TRIM(invoice_extraction_type), '') AS 'Invoice Extraction Type', IFNULL(TRIM(sbi_cost_center_code), '') AS 'SBI Cost Centre', IFNULL(TRIM(sbi_site_code), '') AS 'SBI Site', IFNULL(TRIM(sbi_site_name), '') AS 'SBI Site Name', IF(sbi_billable = 0, 'NO', 'YES') AS 'SBI Billable', IFNULL(TRIM(unique_number), '') AS 'Unique Number', IFNULL(TRIM(alcs_reference_number), '') AS 'ACLS Reference Number', IFNULL(TRIM(revenue_invoice_number), '') AS 'Revenue Invoice Number', IFNULL(DATE_FORMAT(due_date, '%d-%m-%Y'), '') AS 'Due Date', IFNULL(TRIM(finance_approved_by), '') AS 'Finance Approver', IFNULL(DATE_FORMAT(purchase_level_1_approval_date, '%d-%m-%Y %H:%i:%s'), '') AS 'Purchase Date', IFNULL(DATE_FORMAT(purchase_level_2_approval_date, '%d-%m-%Y %H:%i:%s'), '') AS 'Checker Date', IFNULL(DATE_FORMAT(approver_approval_date, '%d-%m-%Y %H:%i:%s'), '') AS 'Approval Date', IFNULL(DATE_FORMAT(finance_approval_date, '%d-%m-%Y %H:%i:%s'), '') AS 'Finance Date', IFNULL(TRIM(invoice_status), '') AS 'Status', IFNULL(TRIM(month_of_service), '') AS 'Month Of Service', IFNULL(TRIM(approver_id), '') AS 'Client Approval Id', IFNULL(TRIM(financial_year), '') AS 'financial_year' FROM payments.approved_invoices 
		where entity_id IN (1,3,4) and invoice_status = '${exception}' and invoice_type = '${selectedOptions123}' and month(invoice_date)=02 and year(invoice_date)=2024;`}

    console.log("payload", payload);
    var getProcessingLayerDataWithStatus = Fetchexecutequery1();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setExtGridData(data);
          setShow(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  function getExceptiontypedata46() {
    let payload;
   
    payload = { query : `SELECT IFNULL(TRIM(vendor_name), '') AS 'Vendor Name', IFNULL(TRIM(vendor_address), '') AS 'Vendor Address', IFNULL(TRIM(place_of_supply), '') AS 'Place Of Supply', IFNULL(TRIM(invoice_number), '') AS 'Invoice Number', IFNULL(DATE_FORMAT(invoice_date, '%d-%m-%Y'), '') AS 'Invoice Date', IFNULL(CONVERT(cgst_percent, CHAR), '0.00') AS 'Cgst Percent', IFNULL(CONVERT(cgst_amount, CHAR), '0.00') AS 'Cgst Amount', IFNULL(CONVERT(sgst_percent, CHAR), '0.00') AS 'Sgst Percent', IFNULL(CONVERT(sgst_amount, CHAR), '0.00') AS 'Sgst Amount', IFNULL(CONVERT(igst_percent, CHAR), '0.00') AS 'Igst Percent', IFNULL(CONVERT(igst_amount, CHAR), '0.00') AS 'Igst Amount', IFNULL(CONVERT(total_invoice_amount, CHAR), '0.00') AS 'Invoice Amount', IFNULL(TRIM(purchase_order_number), '') AS 'PO Number', IFNULL(DATE_FORMAT(purchase_order_date, '%d-%m-%Y'), '') AS 'PO Date', IFNULL(TRIM(cost_center_code), '') AS 'Cost Centre Code', IFNULL(TRIM(approver_mail_id), '') AS 'Approver', IFNULL(TRIM(expense_code), '') AS 'Expense Code', IFNULL(TRIM(expense_category), '') AS 'Expense Category', IFNULL(TRIM(invoice_type), '') AS 'Invoice Type', IFNULL(TRIM(invoice_user_mail_id), '') AS 'Sent By', IFNULL(TRIM(invoice_extraction_type), '') AS 'Invoice Extraction Type', IFNULL(TRIM(sbi_cost_center_code), '') AS 'SBI Cost Centre', IFNULL(TRIM(sbi_site_code), '') AS 'SBI Site', IFNULL(TRIM(sbi_site_name), '') AS 'SBI Site Name', IF(sbi_billable = 0, 'NO', 'YES') AS 'SBI Billable', IFNULL(TRIM(unique_number), '') AS 'Unique Number', IFNULL(TRIM(alcs_reference_number), '') AS 'ACLS Reference Number', IFNULL(TRIM(revenue_invoice_number), '') AS 'Revenue Invoice Number', IFNULL(DATE_FORMAT(due_date, '%d-%m-%Y'), '') AS 'Due Date', IFNULL(TRIM(finance_approved_by), '') AS 'Finance Approver', IFNULL(DATE_FORMAT(purchase_level_1_approval_date, '%d-%m-%Y %H:%i:%s'), '') AS 'Purchase Date', IFNULL(DATE_FORMAT(purchase_level_2_approval_date, '%d-%m-%Y %H:%i:%s'), '') AS 'Checker Date', IFNULL(DATE_FORMAT(approver_approval_date, '%d-%m-%Y %H:%i:%s'), '') AS 'Approval Date', IFNULL(DATE_FORMAT(finance_approval_date, '%d-%m-%Y %H:%i:%s'), '') AS 'Finance Date', IFNULL(TRIM(invoice_status), '') AS 'Status', IFNULL(TRIM(month_of_service), '') AS 'Month Of Service', IFNULL(TRIM(approver_id), '') AS 'Client Approval Id', IFNULL(TRIM(financial_year), '') AS 'financial_year' FROM payments.approved_invoices 
		where entity_id IN (1,3,4) and invoice_type = '${selectedOptions123}' and month(invoice_date)=02 and year(invoice_date)=2024;`}

    console.log("payload", payload);
    var getProcessingLayerDataWithStatus = Fetchexecutequery1();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setExtGridData(data);
          setShow(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }
  function getExceptiontypedata2(exception) {
    console.log("exception",exception)
    let payload;
    if (exception === "Open") {
    payload = { query : `select bank_name,bank_opening_balance,bank_closing_balance,erp_opening_balance,erp_closing_balance from BRS.month_end_closing_balance 
                where lock_status=0 and month = '5-2024';'`};
    } else if (exception === "Closed") {
    payload = { query: `select bank_name,bank_opening_balance,bank_closing_balance,erp_opening_balance,erp_closing_balance from BRS.month_end_closing_balance
               where lock_status=1 and and month = '5-2024';` };
 	       }

    console.log("payload", payload);
    var getProcessingLayerDataWithStatus = Fetchexecutequery();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setExtGridData(data);
          setShow(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }
  const getFirstcarddata = () => {
    getExceptiontypedata(item1.Exception)
  }

  const getFirstcarddata1 = () => {
    getExceptiontypedata(item2.Exception)
  }

  const getFirstcarddata2 = () => {
    getExceptiontypedata(item.Exception)
  }

  const getFirstcarddata3 = () => {
    getExceptiontypedata(item3.Exception)
  }

  const getFirstcarddata4 = (selectedLabel) => {
    getExceptiontypedata1(selectedLabel)
  }

  const getFirstcarddata5 = () => {
    getExceptiontypedata1('Over due')
  }

  const getFirstcarddata6 = (selectedLabel1) => {
    console.log('selectedLabel',selectedLabel1)
    getExceptiontypedata2(selectedLabel1)
  }

  const getFirstcarddata10 = () => {
    getExceptiontypedata1('Pending')
  }

  const getFirstcarddata11 = () => {
    getExceptiontypedata1('Approved')
  }

  const getFirstcarddata12 = () => {
    console.log('called')
    getExceptiontypedata1('Unallocated Credits')
  }

  const getFirstcarddata13 = () => {
    getExceptiontypedata1('Allocated Credits')
  }

  function exportJsonToXLSX(data, sheetName, excelFileName) {
    try {
      var workBook = XLSX.utils.book_new();
      var workSheet = XLSX.utils.json_to_sheet(data, {
        skipHeader: false,
      });
      XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
      XLSX.writeFile(workBook, excelFileName);
      return true;
    }
    catch
    {
      return false;
    }
  }

  function exportToExcel() {
    let fileNameChange = "Report.xlsx";
    let sheetName = "sheet";

    let excelExportData = [];

    for (let i = 0; i < extGridData?.length; i++) {
      let data = {};
      for (let key in extGridData[i]) {
        for (let j = 0; j < modelcolumnnames?.length; j++) {
          if (key === modelcolumnnames[j]["field"]) {
            data[modelcolumnnames[j]["headerName"]] = extGridData[i][key]
          }
        }
      }

      excelExportData.push(data);
    };

    exportJsonToXLSX(excelExportData, sheetName, fileNameChange);

  }



  const cleckedcustomername = (value) => {
    // sidemenulist(value);
    // handleSelection123(value, clientids);
    console.log('clicked');
  }

  const chartState = {
    series: radialseries,
    options: {
      chart: {
        height: 200,
        type: 'radialBar',
        margin: 0,
      },
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 0,
            size: '40%',
            background: '#0a2352',
          },
          dataLabels: {
            value: {
              color: '#fff',
              fontSize: '17px',
              show: true,
              offsetY: 0,
              align: 'center',
            },
            style: {
              fontSize: '160px',
              color: '#fff',
            },
          },
          fill: {
            type: 'solid',
            colors: ['#fffd01'],
          },
          stroke: {
            lineCap: 'round',
          },
        },
      },
      labels: [''],
      colors: ['#fffd01'],
    },
  };


  const [chartState1] = useState({
    series: secounddata,
    options: {
      chart: {
        type: 'donut',
      },
      labels: secoundlabel,
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    },
  });

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const truncateText = (text, maxChars) => {
    return text?.length > maxChars ? text?.slice(0, maxChars) + '...' : text;
  };

  const [imagePath, setImagePath] = useState('../../../assets/images/icici.png');


  const handleInput = (value) => {
    // Do something with the input value received from SearchInput component
    console.log('Input value:', value);
    let filteredData = options.filter(item =>
      item.label.toLowerCase().includes(value.toLowerCase())
    );
    setOptions1(filteredData);
  };

  return (
    <div id="dashboard1main">
    <Grid style={{ marginLeft: '10px' }}>
    <Grid.Row style={{ paddingBottom: '0px',marginTop: '0.2em' }}>
      <Grid.Column style={{ width: '30%', height: '30px', paddingRight: '4px' }}>
        <Input
          type="month"
          className="cardName filetype"
          style={{ paddingRight: '10px', height: '30px', fontSize: '14px' }}
          onChange={(e) => handleChange3(e.target.value)}
          id="file-upload-month"
          value={inputMonth}
        />
      </Grid.Column>
    <Grid.Column style={{ width: '20%', height: '30px', paddingRight: '4px' }}>
        <select
            value={selectedValues}
            onChange={handleChange1}
            style={{
            width: '100%',
            height: '30px',
            fontSize: '14px',
            padding: '5px',
            borderRadius: '4px',
            border: '1px solid rgba(34,36,38,.15)',
            backgroundColor: '#fff',
            boxShadow: '0 1px 2px 0 rgba(34,36,38,.15)',
            color: 'rgba(0,0,0,.87)',
            }}
        >
            <option value="">Choose source name</option>
            {Option123.map(option => (
            <option key={option.value} value={option.value}>{option.value}</option>
            ))}
        </select>
    </Grid.Column>
    <Grid.Column>
        <button className="btn" style={{ height: "35px", width: "7%", borderRadius: "9%", backgroundColor: "#000055", color: "#ffffff" }} onClick={handleChange2}>
            Go
        </button>
    </Grid.Column>

    </Grid.Row>
    <Grid.Row style={{ height: '150px' }}>
        <Grid.Column style={{ width: '28%', paddingRight: '4px' }}>
                <div id="chart1" style={{ border: '1px solid gray', borderRadius: '10px', backgroundColor: 'white' }}>
                <h2 style={{ color: '#3B5999', margin: '0', textAlign: 'center', fontFamily: 'Poppins' }}>GST</h2>
                <ReactApexChart options={chartDatanew1.options} series={chartDatanew1.series} type="donut" height={115} />
                </div>
        </Grid.Column>
        <Grid.Column style={{ width: '22%', paddingRight: '4px'  }}>
            <div id="chart4" style={{ border: '1px solid gray', borderRadius: '10px', backgroundColor: 'white' }}>
                <h2 style={{ color: '#3B5999', margin: '0', textAlign: 'center', fontFamily: 'Poppins' }}>BRS</h2>
                <ReactApexChart options={chartDatanew.options} series={chartDatanew.series} type="donut" height={115} />
            </div>
        </Grid.Column>
        <Grid.Column style={{ width: '45%'}}>
            <div style={{ backgroundColor: 'white', borderRadius: '10px', border: '1px solid #111111', padding: '10px', textAlign: 'center',height: '130px'  }}>
                <h3 style={{ color: '#3B5999', margin: '0', fontFamily: 'Poppins', fontSize: '1.5rem'}}>UTR Mailer</h3>
                <div style={{ height: '85px', marginTop: '-15px' }}> {/* Adjusted height and margin */}
                <ReactApexChart options={chartData2.options} series={chartData2.series} type="bar" height={110} onClick={handleBarClick} />
                </div>
            </div>
        </Grid.Column>
    </Grid.Row>
    <Grid.Row>
        <Grid.Column style={{ width: '20%',paddingTop: '0.5em' }}>
            <div id="chart2" style={{ border: '1px solid gray', borderRadius: '10px', backgroundColor: 'white', marginBottom: '1em' }}>
                <h2 style={{ color: '#3B5999', margin: '0', textAlign: 'center', fontFamily: 'Poppins' }}>INSURANCE</h2>
                <ReactApexChart options={chartDatanew.options} series={chartDatanew.series} type="donut" height={115} />
            </div>
            <div id="chart3" style={{ border: '1px solid gray', borderRadius: '10px', backgroundColor: 'white' }}>
                <h2 style={{ color: '#3B5999', margin: '0', textAlign: 'center', fontFamily: 'Poppins' }}>COMPLIANCE CERTIFICATE</h2>
                <ReactApexChart options={chartDatanew.options} series={chartDatanew.series} type="donut" height={115} />
            </div>
        </Grid.Column>

        <Grid.Column style={{ width: '80%' }}>
            <Grid.Row style={{ paddingTop: '0.5em', justifyContent: 'center',height: '90px' }}>                 
                <div style={{ width: '50%', backgroundColor: 'white', borderRadius: '10px', border: '1px solid #111111' }}>
                <div>
                <h3 style={{ 
                    display: 'inline-block',
                    fontSize: '1.9em',
                    textAlign: 'center',
                    width: 'calc(80% - 10px)', // Adjusted width to accommodate padding and margins
                    color: '#3B5999',
                    margin: '0',
                    fontFamily: 'Poppins, sans-serif',
                    verticalAlign: 'middle', // Align vertically with Dropdown
                    marginRight: '10px' // Right margin for spacing
                }}>
                    Vendor Tool
                </h3>
                <Dropdown
                    placeholder='Select an option'
                    fluid
                    selection
                    options={options123}
                    onChange={changedropdown1}
                    value={selectedOptions123}
                    style={{
                    display: 'inline-block',
                    marginTop: '10px',
                    width: '20%', // Reduced width
                    fontSize: '0.75em', // Reduced font size
                    backgroundColor: '#f0f0f0', // Lighter background color
                    border: '1px solid #ccc', // Lighter border color
                    padding: '0.5em', // Adjust padding for better integration
                    verticalAlign: 'middle' // Align vertically with h3
                    }}
                />
                </div>
                <DynamicDonutChart options={chartData123.labels} series={chartData123.series} onClick={handleChartClick} />
                </div>
                <div style={{ backgroundColor: 'white', borderRadius: '10px', border: '1px solid #111111', width: '50%' }}>
                <h3 style={{ color: '#3B5999', margin: '0', textAlign: 'center', fontFamily: 'Poppins' }}>26AS</h3>
                <ReactApexChart
                    options={chartData1.options}
                    series={chartData1.series}
                    type="bar"
                    height={150}
                    onClick={handleBarClick1}
                />
                </div>

            </Grid.Row>
        </Grid.Column>
        </Grid.Row>
      </Grid>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-11'>

            </div>
            <div className='col-md-1'>
              <a onClick={exportToExcel}>
                <i class='fas fa-file-excel' style={{ fontSize: '30px', color: 'green' }}></i>
              </a>
            </div></div>
          <div className="ag-theme-alpine"
            style={{ height: '400px', width: '100%' }}
          >
            <AgGridReact
              columnDefs={modelcolumnnames}
              rowData={extGridData}
              animateRows={true}

              pagination={true}
              paginationPageSize={10}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DashboardComponent;